<template>
    <div class="seller-base">
        <router-view/>
        <div v-if="$route.meta.footer.show" class='common-footer-wrap'>
            <mt-tabbar v-model='home_selected' fixed class="common-footer">
                <mt-tab-item class='item-wrap' :class="{'active':$route.name=='HomeIndex'}" id='home_index'><router-link :to="{ name: 'HomeIndex'}" class='item'><img src="../../assets/image/seller/icon_home_seller_pre.png" class="image" v-if="$route.name=='HomeIndex'"><img v-else src="../../assets/image/seller/icon_home_seller_nor.png" class="image" /><span class='text'>返回商城</span></router-link></mt-tab-item>
                <mt-tab-item class='item-wrap' :class="{'active':$route.name=='SellerOrderList'}" id='seller_order'><router-link :to="{ name: 'SellerOrderList'}" class='item'><img src="../../assets/image/seller/icon_list_seller_pre.png" class="image" v-if="$route.name=='SellerOrderList'"><img v-else src="../../assets/image/seller/icon_list_seller_nor.png" class="image" /><span class='text'>订单管理</span></router-link></mt-tab-item>
                <mt-tab-item class='item-wrap' :class="{'active':$route.name=='SellerIndex'}" id='seller_index'><router-link :to="{ name: 'SellerIndex'}" class='item'><img src="../../assets/image/seller/icon_mine_seller_pre.png" class="image" v-if="$route.name=='SellerIndex'"><img v-else src="../../assets/image/seller/icon_mine_seller_nor.png" class="image" /><span class='text'>店铺中心</span></router-link></mt-tab-item>
            </mt-tabbar>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'SellerBase',
  data () {
    return {
      home_selected: 'seller_index'
    }
  },
  computed: {
    ...mapState({
      user: state => state.seller.info
    })
  },
  created: function () {
    if (!this.user) {
      this.$router.push({ name: 'HomeSellerLogin' })
    }
  }
}
</script>
<style lang="scss" scoped>
    .image{
        width:1rem;
        height:1rem;
        display:block;
        margin-left:auto;
        margin-right:auto;
        margin-top:.2rem;
        margin-bottom:.2rem;
    }
</style>
